import { Routes } from '@angular/router';
import { AppLayout } from '@/app/layout/components/app.layout';
import { Notfound } from '@/app/pages/notfound/notfound';
import { authGuard } from '@/app/core/auth/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboards/ejecutivo'
            },
            {
                path: 'dashboards/ejecutivo',
                loadChildren: () => import('@/app/features/dashboard-ceo/dashboard-ceo.routes'),
                data: { breadcrumb: 'Dashboard Ejecutivo' }
            },
            {
                path: 'dashboards/operaciones',
                loadChildren: () => import('@/app/features/dashboard-operations/dashboard-operations.routes'),
                data: { breadcrumb: 'Operaciones' }
            },
            {
                path: 'dashboards/usuarios',
                loadChildren: () => import('@/app/features/dashboard-users/dashboard-users.routes'),
                data: { breadcrumb: 'Dashboard Usuarios' }
            },
            {
                path: 'emissions',
                loadChildren: () => import('@/app/features/emissions/emissions.routes'),
                data: { breadcrumb: 'Emisiones' }
            },
            {
                path: 'endorsements',
                loadChildren: () => import('@/app/features/endorsements/endorsements.routes'),
                data: { breadcrumb: 'Endosos' }
            },
            {
                path: 'warrants',
                loadChildren: () => import('@/app/features/warrants/warrants.routes'),
                data: { breadcrumb: 'Detalle de emisión' }
            },
            {
                path: 'users',
                loadChildren: () => import('@/app/features/users/users.routes'),
                data: { breadcrumb: 'Usuarios' }
            },
            {
                path: 'organizations',
                loadChildren: () => import('@/app/features/organizations/organizations.routes'),
                data: { breadcrumb: 'Organizaciones' }
            },
            {
                path: 'billing-profiles',
                loadChildren: () => import('@/app/features/billing-profiles/billing-profiles.routes'),
                data: { breadcrumb: 'Perfiles de facturación' }
            },
            {
                path: 'billable-items',
                loadChildren: () => import('@/app/features/billable-items/billable-items.routes'),
                data: { breadcrumb: 'Cargos pendientes' }
            },
            {
                path: 'products',
                loadChildren: () => import('@/app/features/products/products.routes'),
                data: { breadcrumb: 'Catálogo' }
            },
            {
                path: 'invoices',
                loadChildren: () => import('@/app/features/invoices/invoices.routes'),
                data: { breadcrumb: 'Facturas' }
            },
            {
                path: 'collections',
                loadChildren: () => import('@/app/features/collections/collections.routes'),
                data: { breadcrumb: 'Cobranza' }
            }
        ]
    },
    {
        path: 'auth',
        loadChildren: () => import('@/app/pages/auth/auth.routes')
    },
    { path: 'notfound', component: Notfound },
    { path: '**', redirectTo: '/notfound' }
];
